import React from 'react';
import { ExpandableSection } from 'AWS-UI-Components-React';
import { ViewByTimeFrame } from './view_by_timeframe';
import { aggregateByTimeframe } from './utils';

/**
 * Given a map of test results by marketplace,
 * renders the test results putting each marketplace
 * in an expandable section which display the
 * corresponding test results upon expansion.
 */
export class ViewByMarketplace extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  getHeader = (marketplace) => {
    const { marketplaceLabelsById } = this.props;
    return marketplaceLabelsById[marketplace] || 'Not marketplace specific';
  };

  render() {
    const { title, chart, testResultsByMarketplace } = this.props;

    return (
      <div>
        <h2>{title}</h2>
        <div>{chart ? chart : ''}</div>
        {Object.keys(testResultsByMarketplace).map((marketplace) => {
          const byTimeFrame = aggregateByTimeframe(testResultsByMarketplace[marketplace]);
          return (
            <ExpandableSection
              key={'TestResultsByMarketplaceExpandableSection' + marketplace}
              header={this.getHeader(marketplace)}
              variant="borderless"
            >
              <div className="awsui-util-container">
                <ViewByTimeFrame
                  key={'TestResultsByMarketplaceTimeFrame' + marketplace}
                  testResultsByTimeFrame={byTimeFrame}
                  title={''}
                  loadValidationTestResults={this.props.loadValidationTestResults}
                />
              </div>
            </ExpandableSection>
          );
        })}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/simulator/validation_test_results/view_by_marketplace.jsx